class AttributeUtils {
  static convertAttributesToList(attributesObj, disableUpdate, forFields) {
    forFields = forFields || [];
    let attributes = [];
    Object.keys(attributesObj).forEach(name => (
      attributes.push(
        {
          "name": name,
          "dataType": AttributeUtils.findDataType(attributesObj[name]),
          "value": attributesObj[name],
          "disableUpdate": forFields.indexOf(name) != -1 ? disableUpdate : false,
          "disableDelete": false,
          "hasError": false,
          "hasNameError": name.trim().length == 0,
          "isDuplicate": false,
        }
      )
    ));

    return attributes;
  }

  static convertAttributesToObject(attributesList) {
    let attributes = {};
    attributesList.forEach(attr => {
      attributes[attr.name] = attr.value;
    })
    return attributes;
  }

  static convertValue(attribute, value) {
    if (attribute.dataType == 'Number') {
      value = parseFloat(value);
    }
    return value;
  }

  static initAttributeValue(dataType, currentVal) {
    let value = "";
    if (dataType == 'Number') {
      value = typeof currentVal == 'number' ? currentVal : 0;
    } else if (dataType == 'Boolean') {
      value = typeof currentVal == 'boolean' ? currentVal : false;
    } else if (dataType == 'Advanced') {
      value = typeof currentVal == 'object' ? currentVal : {};
    }
    return value;
  }

  static findDataType(value) {
    let dataType = "String";
    let type = typeof value;
    if (type == "number") {
      dataType = "Number";
    } else if (type == 'boolean') {
      dataType = "Boolean";
    } else if (type == 'object') {
      dataType = "Advanced";
      if (value && value.type) {
        let type = value.type.toLowerCase();
        if (type == 'image') {
          dataType = 'Image';
        } else if (type == 'file') {
          dataType = 'File';
        }
      }
    }
    return dataType;
  }

  static isDuplicate(attributes, name, index) {
    let i = attributes.findIndex((attr, i) => (i != index && attr.name == name));
    return i != -1;
  }

  static hasOriginalDataChanged(originalAttributes, newAttributes) {
    if (originalAttributes) {
      return Object.keys(originalAttributes).some((key) => {
        if (newAttributes.hasOwnProperty(key) &&
          AttributeUtils.findDataType(originalAttributes[key]) === AttributeUtils.findDataType(newAttributes[key]) &&
          typeof originalAttributes[key] === 'object') {
          return AttributeUtils.hasOriginalDataChanged(originalAttributes[key], newAttributes[key]);
        } else if (!(newAttributes.hasOwnProperty(key) &&
          AttributeUtils.findDataType(originalAttributes[key]) === AttributeUtils.findDataType(newAttributes[key]) &&
          typeof originalAttributes[key] !== 'object')) {
          return true;
        }
      });
    }
    return false;
  }

  static convertToErrorMessage(errors) {
    let err = "Invalid Data:<br><ul>";
    Object.keys(errors).forEach(e => {
      let error = errors[e];
      if ((typeof error) == "object") {
        error = error[0];
      }

      err += `<li>${e}: ${error}</li>`
    });
    err += "</ul>";
    return err;
  }
}

export default AttributeUtils;
